import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Cookies from 'js-cookie';
import { defineStore } from 'pinia';
import { FAMILY_PROFILE_UUID_STORAGE_KEY } from '~/core/constants/sessionStorage';
import { CookieKey } from '~/core/enums';
import { MedcardStatus } from '~/features/Profile/enums';
import { MedcardApi } from '~/features/Medcard/api/medcard.api';
import { HealthDiariesApi, HealthDiariesStatus } from '~/features/Medcard/api/diaries';
var MEDCARD_TOKEN_EXPIRES_DAYS = 14;
export default defineStore('medcard', function () {
  var _useNuxtApp = useNuxtApp(),
    $captureException = _useNuxtApp.$captureException;
  var status = ref(MedcardStatus.Protected);
  var masterToken = ref('');
  var familyProfileUuid = ref(sessionStorage.getItem(FAMILY_PROFILE_UUID_STORAGE_KEY));
  var isMedcardTokenValid = computed(function () {
    return status.value === MedcardStatus.Available;
  });
  var healthDiariesStatus = ref(HealthDiariesStatus.Empty);
  var healthDiariesStatusForFamilyProfile = ref(HealthDiariesStatus.Empty);
  function setFamilyProfileUuid(uuid) {
    familyProfileUuid.value = uuid;
    sessionStorage.setItem(FAMILY_PROFILE_UUID_STORAGE_KEY, uuid);
  }
  function getMasterToken() {
    return _getMasterToken.apply(this, arguments);
  }
  function _getMasterToken() {
    _getMasterToken = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$MedcardApi$get, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return MedcardApi.getMedcardToken();
          case 2:
            _yield$MedcardApi$get = _context.sent;
            data = _yield$MedcardApi$get.data;
            masterToken.value = data.masterMedcardToken;
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getMasterToken.apply(this, arguments);
  }
  function setMedcardToken(_x) {
    return _setMedcardToken.apply(this, arguments);
  }
  function _setMedcardToken() {
    _setMedcardToken = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(token) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            Cookies.set(CookieKey.MedcardToken, token, {
              expires: MEDCARD_TOKEN_EXPIRES_DAYS
            });
            _context2.next = 3;
            return checkMedcard();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _setMedcardToken.apply(this, arguments);
  }
  function checkMedcard() {
    return _checkMedcard.apply(this, arguments);
  }
  function _checkMedcard() {
    _checkMedcard = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$MedcardApi$get2, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return MedcardApi.getStatus();
          case 3:
            _yield$MedcardApi$get2 = _context3.sent;
            data = _yield$MedcardApi$get2.data;
            status.value = data.medcardStatus;
            _context3.next = 11;
            break;
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            $captureException(_context3.t0, {
              component: 'useMedcardStore',
              method: 'checkMedcard'
            });
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 8]]);
    }));
    return _checkMedcard.apply(this, arguments);
  }
  function fetchHealthDiariesStatus() {
    return _fetchHealthDiariesStatus.apply(this, arguments);
  }
  function _fetchHealthDiariesStatus() {
    _fetchHealthDiariesStatus = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _yield$HealthDiariesA, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return HealthDiariesApi.getState();
          case 3:
            _yield$HealthDiariesA = _context4.sent;
            data = _yield$HealthDiariesA.data;
            healthDiariesStatus.value = data.diaryStatus;
            _context4.next = 11;
            break;
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            $captureException(_context4.t0, {
              component: 'useMedcardStore',
              method: 'fetchHealthDiariesStatus',
              message: 'Не удалось загрузить статус дневников здоровья'
            });
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 8]]);
    }));
    return _fetchHealthDiariesStatus.apply(this, arguments);
  }
  function fetchHealthDiariesStatusForFamilyProfile() {
    return _fetchHealthDiariesStatusForFamilyProfile.apply(this, arguments);
  }
  function _fetchHealthDiariesStatusForFamilyProfile() {
    _fetchHealthDiariesStatusForFamilyProfile = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var _yield$HealthDiariesA2, data;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (familyProfileUuid.value) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            _context5.prev = 2;
            _context5.next = 5;
            return HealthDiariesApi.getState(familyProfileUuid.value);
          case 5:
            _yield$HealthDiariesA2 = _context5.sent;
            data = _yield$HealthDiariesA2.data;
            healthDiariesStatusForFamilyProfile.value = data.diaryStatus;
            _context5.next = 13;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](2);
            $captureException(_context5.t0, {
              component: 'useMedcardStore',
              method: 'fetchHealthDiariesStatus',
              message: 'Не удалось загрузить статус дневников здоровья'
            });
          case 13:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 10]]);
    }));
    return _fetchHealthDiariesStatusForFamilyProfile.apply(this, arguments);
  }
  return {
    status: status,
    masterToken: masterToken,
    familyProfileUuid: familyProfileUuid,
    isMedcardTokenValid: isMedcardTokenValid,
    healthDiariesStatus: healthDiariesStatus,
    healthDiariesStatusForFamilyProfile: healthDiariesStatusForFamilyProfile,
    setFamilyProfileUuid: setFamilyProfileUuid,
    getMasterToken: getMasterToken,
    setMedcardToken: setMedcardToken,
    checkMedcard: checkMedcard,
    fetchHealthDiariesStatus: fetchHealthDiariesStatus,
    fetchHealthDiariesStatusForFamilyProfile: fetchHealthDiariesStatusForFamilyProfile
  };
});